import React from 'react';
import { HyperdbForm } from '../../../../hyperdb';
import { TextInput, LongTextInput, CheckBox } from 'hyperdb-utils';
import { EntityForm } from '../../../address-book/entity';

export default class Form extends React.Component {
  constructor(props) {
    super(props);
    this.handleChangeEntity = this.handleChangeEntity.bind(this);
  }
  render() {
    const entity = this.props.objectData.entity_data || {};
    return (
      <fieldset>
        <CheckBox
          label="Send email on booking/cancellation"
          name="send_booking_notification"
          checked={ this.props.objectData.send_booking_notification }
          onChange={ this.handleClickCheckbox.bind(this, 'send_booking_notification') }
        />
        <CheckBox
          label="Send email on booking update"
          name="send_booking_update"
          checked={ this.props.objectData.send_booking_update }
          onChange={ this.handleClickCheckbox.bind(this, 'send_booking_update') }
          disabled={ !this.props.objectData.send_booking_notification }
        />
        <EntityForm entity={ entity } onChange={ this.handleChangeEntity } mode="owner" />
        <TextInput
          label="Company name"
          name="company"
          value={ this.props.objectData.company }
          onChange={ this.handleChange.bind(this, 'company') }
          />
        <TextInput
          label="CC emails"
          name="cc_emails"
          value={ this.props.objectData.cc_emails }
          onChange={ this.handleChange.bind(this, 'cc_emails') }
        />
        <LongTextInput
          label="Notes"
          name="notes"
          value={ this.props.objectData.notes }
          onChange={ this.handleChange.bind(this, 'notes') }
        />
      </fieldset>
    );
  }

  handleChange(attributeName, field) {
    const { name, value } = field;
    this.props.api.owner.updateEditedObject({ attributeName, value });
  }
  handleChangeEntity(attributes) {
    this.handleChange('entity_data', { value: attributes });
    const entity = { ...this.props.objectData.entity };
    entity.value[1] = attributes.id;
    this.handleChange('entity', { value: entity });
  }
  handleClickCheckbox(attributeName) {
    const value = !this.props.objectData[attributeName];
    this.handleChange(attributeName, { value });
    if (attributeName === 'send_booking_notification' && !value) {
      this.handleChange('send_booking_update', { value: false });
    }
  }
}

Form.propTypes = {
  api: React.PropTypes.object,
  objectData: React.PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/owner/components/Form.jsx